import { IGeoPos } from './geographicalpos.model';
import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AnyAction } from 'redux';

@Injectable()
export class GeoPosActionService {

    static GEOPOS_LIST = 'GEOPOS_LIST';
    static DELETE_GEOPOS = 'DELETE_GEOPOS';
    static ADD_GEOPOS = 'ADD_GEOPOS';
    static MODIFY_GEOPOS = 'MODIFY_GEOPOS';
    static SET_GEOPOS_CURRENT = 'SET_GEOPOS_CURRENT';

    constructor() {

    }

    @dispatch()
    geoposList = ( data ): AnyAction => ({ type: GeoPosActionService.GEOPOS_LIST, payload: data })

    @dispatch()
    addGeoPos = ( data: IGeoPos ): AnyAction => ({ type: GeoPosActionService.ADD_GEOPOS, payload: data })

    @dispatch()
    deleteGeoPos = ( data ): AnyAction => ({ type: GeoPosActionService.DELETE_GEOPOS, payload: data })

    @dispatch()
    modifyGeoPos = ( data ): AnyAction => ({ type: GeoPosActionService.MODIFY_GEOPOS, payload: data })

    @dispatch()
    setGeoPosCurrent = ( data ): AnyAction => ({ type: GeoPosActionService.SET_GEOPOS_CURRENT, payload: data })

}
